module.exports = __webpack_public_path__ + "static/media/main1.890397f1.jpg";